import { ReactElement } from 'react';

import { Header } from '@beeline/lk-ui';
import { useParams, getAuth } from '@beeline/lk-utils';

import styles from './styles.module.scss';

import { useProfile } from ':api/common/useProfile';
import { Link, Dashboard, BrowserTitle, WithHDButtons } from ':components';
import { AnalyticsTrackPageView } from ':components/Analytics/AnalyticsTrackPageView';

export function DashboardPage(): ReactElement {
  const { employeeNumber } = useParams();
  const authUserName = getAuth()?.getClaims()?.given_name ?? '';
  let userName = '';

  const { data, isLoading } = useProfile(
    getAuth()?.getClaims()?.['Employee-Number'] ?? '',
  );

  let title = '';

  if (!isLoading) {
    userName = data?.first_name ?? authUserName;
    title = employeeNumber
      ? 'Дашборд'
      : `Привет${userName ? ', ' : ''}${userName}`;
  }

  return (
    <WithHDButtons>
      <>
        <BrowserTitle title='Дашборд' />
        <AnalyticsTrackPageView />
        <div className={styles.mainContainer}>
          <div className={styles.innerContainer}>
            <Header
              title={title}
              breadcrumbsProps={
                employeeNumber
                  ? {
                      children: [
                        <Link disableVisited to='/' key='dashboard'>
                          Мой дашборд
                        </Link>,
                        <span key='last' />,
                      ],
                    }
                  : undefined
              }
            />
            <Dashboard />
          </div>
        </div>
      </>
    </WithHDButtons>
  );
}
